import { Component } from '@angular/core';
import { GlobalService } from './services/global.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {

  constructor (private translate: TranslateService){
    this.translate.setDefaultLang('fr');
  }

  switchLanguage(language: string){
    this.translate.use(language);
  }

  title = 'Teliya santé';
}
